<template>
  <div :class="['productList', { inApp: $root.$data.isApp || this.$root.miniprogram }]" id="yd-page5">
    <common-title titleName="课程列表" :bcColor="'#FEFEFF'" :zIndex="1000"></common-title>
    <div class="content">
      <van-list :finished="true" v-model="loading" :immediate-check="false" v-if="courseList.length">
        <ul class="courseList">
          <li v-for="(item, keys) in courseList" :key="keys">
            <CombinationCard v-if="item.setType === 1" :item="item" :index="keys" />
            <HotCourseCard v-else :item="item" :key="keys" />
          </li>
        </ul>
      </van-list>
      <EmptyData :emptyName="'noProductList'" v-if="listEmpty" />
      <Foot />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// eslint-disable-next-line import/no-cycle
import {
  reqProductList,
} from '@/api/home';
import {deepCopy, loadMantisChat, setBaseUrl} from '@/utils/tools';
import CommonTitle from '@/components/header/CommonTitle.vue';
import EmptyData from '@/components/emptyData/emptyData.vue';
import Foot from '@/components/foot/privacy.vue';
import CombinationCard from '@/components/combinationCard/combinationCard.vue';
import HotCourseCard from '../../components/hotCourseCard/hotCourseCard.vue';

export default {
  components: {
    CommonTitle,
    HotCourseCard,
    EmptyData,
    Foot,
    CombinationCard,
  },
  data() {
    return {
      courseList: [], // 课程列表
      loading: false,
      listEmpty: false, // 在loading时不显示缺省页
    };
  },
  computed: {
    ...mapState(['userInfo']),
  },
  async created() {
    // this.$nextTick(() => {
    //   this.$refs.load.show = true;
    // });
    this.getCourse();
  },
  mounted() {
    // 小程序不需要客服
    if (!this.$root.$data?.miniprogram) {
      loadMantisChat(this.userInfo);
    }
  },
  methods: {
    // 请求产品列表
    async getCourse() {
      this.$toast.loading({
        message: '加载中...',
        forbidClick: false,
        duration: 0,
      });
      const {
        type,
      } = this.$route.query;

      const res = await reqProductList(this.getPayloadInfo(type));
      if (res.code === 0 && res.data) {
        this.loading = false;
        this.courseList = [...this.resetCourse(res.data.data || [])];
        if (!res.data.data.length) {
          this.listEmpty = true;
        }
      } else {
        // this.$refs.load.show = false;
        this.listEmpty = true;
      }
      this.$toast.clear();
    },

    resetCourse(majorCourseList) {
      majorCourseList.forEach((item) => {
        const copyItem = deepCopy(item)
        const { productDiscountRespVO, teacherRespVOS } = item;
        Object.assign(item, {
          isArk: 1,
          salesVolume: Number(item.realSales) + Number(item.initialSales),
          courseBeginTime: item.startTime, // 开课时间
          isUnionDiscount: productDiscountRespVO?.isUnionDiscount, // 联报
          isCouponDiscount: productDiscountRespVO?.isCouponDiscount, // 优惠券
          teacherRespVOS: teacherRespVOS?.map((teacher) => ({
            teacherHead: teacher.teacherHead ? teacher.teacherHead : '',
            name: teacher.name,
          })),
        });
        if (
          productDiscountRespVO?.isCouponDiscount
          && productDiscountRespVO?.couponDiscount
          && item.sellPrice > 0
          && !productDiscountRespVO?.promotionLabel
        ) {
          Object.assign(item, {
            promotionLabel: 4,
            originalPrice: item.sellPrice,
            sellPrice: productDiscountRespVO.discountPrice,
          });
        }
        if (productDiscountRespVO?.promotionLabel) {
          Object.assign(item, {
            promotionLabel: productDiscountRespVO?.promotionLabel,
            originalPrice: (
              Number(productDiscountRespVO.discountMinPrice)
              + Number(productDiscountRespVO.discountAmount)
            ).toFixed(2),
            sellPrice: productDiscountRespVO.discountMinPrice,
            acvitityShowTime: productDiscountRespVO?.promotionShowTime,
            acvitityStartTime: productDiscountRespVO?.promotionBeginTime,
            acvitityEndTime: productDiscountRespVO?.promotionEndTime,
          });
        }
        if (productDiscountRespVO?.isGroupDiscount) {
          Object.assign(item, {
            promotionLabel: 5,
            originalPrice: copyItem.sellPrice,
            sellPrice: productDiscountRespVO.discountMinPrice,
          });
        }
      });
      return majorCourseList;
    },
    /**
     * @param type // 1 张宇刷题 2政治千题练 3背单词 4田静长难句
     */
    getPayloadInfo(type) {
      const baseUrl = setBaseUrl();
      let env = '';
      switch (true) {
        case baseUrl.includes('mobile-dev'):
          env = 'dev';
          break;
        case baseUrl.includes('mobile-test'):
          env = 'test';
          break;
        default:
          env = 'release';
          break;
      }

      // attributeId
      const attributeIdMap = {
        dev: 78,
        test: 78,
        release: 5,
      };

      // pageSize
      const pageSizeMap = {
        1: 3,
        2: 1,
        3: 2,
        4: 2,
        6: 2
      };

      // categoryId
      const categoryIdMap = {
        dev: {
          1: 112,
          2: 114,
          3: 111,
          4: 111,
          6: 111,
        },
        test: {
          1: 112,
          2: 114,
          3: 111,
          4: 111,
          6: 111,
        },
        release: {
          1: 9,
          2: 7,
          3: 8,
          4: 8,
          6: 8,
        },
      };
      return this.setPayload({
        pageSize: pageSizeMap[type],
        attributeId: attributeIdMap[env],
        productCategoryIds: [categoryIdMap[env][type]],
      });
    },
    setPayload(info) {
      const { pageSize, attributeId, productCategoryIds } = info;
      return {
        pageNum: 1,
        productCategoryIds,
        pageSize,
        attributeReqVOList: [{ attributeId, attributeValue: '2', type: 2 }],
        platform: 1,
        endPoint: 8,
        isShow: 1,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .van-pull-refresh {
  height: 100%;
  overflow: inherit;
}

.productList {
  position: absolute;
  width: 100%;
  height: 100%;
  padding: 100px 36px 0 36px;
  background: #fefeff;

  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }

  .content {
    height: 100%;
  }

  .courseList {
    box-sizing: border-box;
    width: 100%;
    min-height: 98px;
    padding: 20px 0 100px 0;
    background: #fff;
  }

  .courseList>li {
    position: relative;
    width: 686px;
    // height: 3.06px;
    // border: 1px solid red;
    // display: flex;
    // flex-wrap: nowrap;
    margin: 0 auto;
    margin-bottom: 25px;
    padding: 0.32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 16px;
    // box-shadow: 0 4px 24px rgba(240, 244, 244, 1);
    opacity: 1;

    .liveImg {
      position: absolute;
      top: 0;
      right: 0;
      width: 140px;
      height: 50px;
      border-radius: 0 16px 0 32px;
    }
  }

  ::v-deep .common-foot {
    position: fixed;
  }
}
</style>
